import { useMemo } from 'react'

import { useSpecificCategory } from '@zet/common/hooks/useSpecificCategory'
import { ICategoryCard } from '@zet/feature-brands/components/categoryCard'
import { i18n } from '@zet/localization'
import { Categories } from '@zet/utils/Constants'

import { getSvgIcon } from '../utils'

let CATEGORY_DATA: ICategoryCard[] = []

const useGetCategories = ({ data }) => {
  const { category } = useSpecificCategory()

  useMemo(() => {
    CATEGORY_DATA = []
    data?.forEach(({ categoryId, categoryName, earnUpto }) => {
      if (!category) {
        CATEGORY_DATA.push({
          id: categoryId,
          title: categoryName,
          svgIcon: getSvgIcon(categoryId),
          subtitle:
            categoryId === 21
              ? i18n.t('categories.zetCategory', { amount: earnUpto })
              : categoryId === Categories.ZET_STORE
              ? i18n.t('categories.earnFlat', { earnUpto })
              : earnUpto
              ? i18n.t('categories.earnUpto', { earnUpto })
              : '',
        })
      } else {
        if (category === categoryId) {
          CATEGORY_DATA.push({
            id: categoryId,
            title: categoryName,
            svgIcon: getSvgIcon(categoryId),
            subtitle:
              categoryId === 21
                ? i18n.t('categories.zetCategory', { amount: earnUpto })
                : categoryId === Categories.ZET_STORE
                ? i18n.t('categories.earnFlat', { earnUpto })
                : earnUpto
                ? i18n.t('categories.earnUpto', { earnUpto })
                : '',
          })
        }
      }
    })
  }, [category, data])

  return { CATEGORY_DATA }
}

export default useGetCategories
